// extracted by mini-css-extract-plugin
export default {"section":"RoleModal-module__section___VqxPI","sectionTitle":"RoleModal-module__sectionTitle___ayw7l"};